import PropTypes from 'prop-types'

export const ratingShape = {
  arrieve: PropTypes.number,
  communication: PropTypes.number,
  emplacement: PropTypes.number,
  precision: PropTypes.number,
  prop: PropTypes.number,
  quality_prix: PropTypes.number,
  score: PropTypes.number,
}
